import { render, staticRenderFns } from "./resi.html?vue&type=template&id=6ecd17ba&scoped=true&"
import script from "./Resi.vue?vue&type=script&lang=js&"
export * from "./Resi.vue?vue&type=script&lang=js&"
import style0 from "./Resi.vue?vue&type=style&index=0&id=6ecd17ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ecd17ba",
  null
  
)

export default component.exports